import Input from "../../../../../../components/Input";
import InputSelect from "../../../../../../components/Input-select";
import { IFormModalDebitHours } from "../../models";

export function FormModalDebitHours({
  modalValue,
  LIST_OPTION_DEBIT,
  optionSelect,
  handleSubmitForm,
  saveValueOfField,
  setOptionSelect,
  handleClickExitModal,
  verefyValueOfDebit,
}: IFormModalDebitHours) {
  return (
    <form onSubmit={handleSubmitForm} className="modal-debit-hours-management gap between column">
      <div className="row-input-modal-hours-management flex box-row">
        <Input
          name="value"
          label="Valor a debitar"
          placeholder="Digite o valor em horas"
          type="number"
          value={modalValue?.value}
          setValue={(e) => {
            verefyValueOfDebit(e.target.value);
            saveValueOfField(e.target);
          }}
          required
        />
        <InputSelect
          name="formatDebit"
          label="Formato do débito"
          placeholder="Selecionar"
          list={LIST_OPTION_DEBIT}
          value={optionSelect}
          onChange={(e) => setOptionSelect(+e.target.value)}
          required
        />
      </div>
      <div className="row-input-modal-hours-management flex box-row">
        <Input
          name="observation"
          label="Observações"
          placeholder="Digite uma observação"
          value={modalValue?.observation}
          setValue={(e) => saveValueOfField(e.target)}
        />
      </div>
      <div className="btn-modal-debit-hours-management flex box-row">
        <button type="submit" className="btn bg-primary">
          SALVAR
        </button>
        <button onClick={handleClickExitModal} type="reset" className="btn bg-secondary">
          LIMPAR
        </button>
      </div>
    </form>
  );
}
